import  {Component} from 'react';
import {connect} from 'react-redux';
import {signOut} from './actions';

class SignOut extends Component {

    componentWillMount() {
        this.props.signOut();
    }

    render() {
        return null;
    }
}

export default connect(null, {signOut })(SignOut);


// WEBPACK FOOTER //
// ./src/containers/auth/sign_out.js